import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
import { DelegasiRiwayatDetailModalComponent } from '../delegasi-riwayat-detail-modal/delegasi-riwayat-detail-modal.component';

@Component({
  selector: 'app-delegasi-riwayat',
  templateUrl: './delegasi-riwayat.component.html',
  styleUrls: ['./delegasi-riwayat.component.scss'],
})
export class DelegasiRiwayatComponent implements OnInit {
  load = false;
  rows: any[] = [];
  page = 1;
  pageInfo: any = {};

  constructor(
    private modalController: ModalController,
    private api: ApiService,
    private util: UtilService
  ) {}

  ngOnInit(): void {
    this.loadRows();
  }

  loadRows() {
    this.load = true;
    const form = JSON.stringify({
      q: {},
      page: this.page,
      rows: 20,
    });

    this.api.post('backoffice/delegasi/riwayat-pindah-kelompok', form).subscribe(
      (data: any) => {
        this.load = false;
        if (data?.error == 0) {
          const list = Array.isArray(data?.data?.rows) ? data.data.rows : [];
          this.pageInfo = data?.data || {};
          this.rows = list.map((item: any, index: number) => this.mapRow(item, index));
        } else {
          this.rows = [];
          this.pageInfo = {};
          this.util.showToast(data?.message || 'Gagal memuat riwayat', 'danger', 'bottom');
        }
      },
      (error) => {
        this.load = false;
        this.rows = [];
        this.pageInfo = {};
        this.api.errorCond(error);
      }
    );
  }

  private mapRow(item: any, index: number) {
    const oldGroup = item?.old_group || {};
    const newGroup = item?.new_group || {};
    const membersRaw = Array.isArray(item?.members) ? item.members : [];
    const members = this.uniqueMembers(membersRaw).map((m: any) => ({
      lead_id: m.lead_id || '',
      lead_name: m.name || '',
      from_team: oldGroup.team_name || '-',
      to_team: newGroup.team_name || '-',
      new_role: this.mapNewRole(m),
    }));

    const sales = newGroup.sales || oldGroup.sales || {};
    const limit = Number(this.pageInfo?.limit) || 20;
    const no = (this.page - 1) * limit + index + 1;

    return {
      no,
      source_group_name: oldGroup.group_name || '-',
      target_group_name: newGroup.group_name || '-',
      source_group_id: oldGroup.id || '-',
      target_group_id: newGroup.id || '-',
      moved_count: members.length,
      remaining_source: item?.remaining_source,
      operator: sales.id || sales.name || '-',
      branch_id: item?.branch_id || sales.branch_id || '-',
      branch_name: sales.branch_name || '',
      executed_at: item?.execution_time || '-',
      members,
      raw: item,
    };
  }

  private mapNewRole(member: any): string {
    const isGroupsLeader = !!member?.is_groups_leader;
    const isTeamsLeader = !!(member?.is_teams_leader ?? member?.is_team_leader);

    if (isGroupsLeader && isTeamsLeader) {
      return 'Ketua Kelompok & Regu';
    }
    if (isGroupsLeader) {
      return 'Ketua Kelompok';
    }
    if (isTeamsLeader) {
      return 'Ketua Regu';
    }
    return 'Anggota';
  }

  private uniqueMembers(list: any[]): any[] {
    const seen = new Set<string>();
    const result: any[] = [];
    for (const item of list) {
      const key = String(item?.lead_id || '').trim();
      if (!key || seen.has(key)) {
        continue;
      }
      seen.add(key);
      result.push(item);
    }
    return result;
  }

  firstPage() {
    this.page = 1;
    this.loadRows();
  }

  prevPage() {
    this.page = this.page - 1;
    this.loadRows();
  }

  nextPage() {
    this.page = this.page + 1;
    this.loadRows();
  }

  lastPage() {
    this.page = this.pageInfo?.total_pages || 1;
    this.loadRows();
  }

  async openDetail(row: any) {
    const modal = await this.modalController.create({
      component: DelegasiRiwayatDetailModalComponent,
      cssClass: 'modal-riwayat-pindah-detail',
      backdropDismiss: false,
      componentProps: {
        data: row,
      },
    });
    return await modal.present();
  }
}
